export class Impostos {
  Qtd: number;
  ValorUni: number;
  Desconto: number;
  Frete: number;
  Produto: String;
  tpop: String;
  Despesa: number;
}
